import { Table, Text } from '@mantine/core';

import { AnnualReportOverviewCount } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Content } from '@/core/components';

interface TextCountProps {
  overview: AnnualReportOverviewCount;
}

export function TextCount({ overview: { textsCount } }: TextCountProps) {
  return (
    <Content type="full">
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w="80%">Numărul cărților științifice publicate</Table.Th>
            <Table.Td>
              <Text
                fs="xl"
                fw="500"
              >
                {textsCount.totalCount}
              </Text>
            </Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Cărți apărute în edituri internaționale</Table.Th>
            <Table.Td>{textsCount.booksCount.internationalBooksCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Cărți apărute în edituri naționale, recunoscute CNCS</Table.Th>
            <Table.Td>{textsCount.booksCount.cncsBooksCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Capitole în cărți apărute în edituri internaționale</Table.Th>
            <Table.Td>{textsCount.chaptersCount.internationalChaptersCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Capitole în cărți apărute în edituri naționale, recunoscute CNCS</Table.Th>
            <Table.Td>{textsCount.chaptersCount.cncsChaptersCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Cursuri, îndrumătoare de lucrări practice/seminarii publicate</Table.Th>
            <Table.Td>{textsCount.coursesCount}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Content>
  );
}
